import React from 'react';
import { Box } from '@mui/material';

interface Props {
  type: 'horizontal' | 'vertical';

  value: number;
  onChange: (value: number) => void;
}

const SIZE = '2px';
const OFFSET = '-4px';

export function ResizeDivider({ type: direction, value, onChange }: Props) {
  const isHorizontal = direction === 'horizontal';

  return (
    <Box
      sx={{
        ...(isHorizontal ? { width: SIZE, minWidth: SIZE } : { height: SIZE, minHeight: SIZE }),

        background: (theme) => theme.palette.divider,
        cursor: isHorizontal ? 'col-resize' : 'row-resize',

        position: 'relative',

        '&:before': {
          content: '""',
          position: 'absolute',
          ...(isHorizontal
            ? { top: 0, bottom: 0, left: OFFSET, right: OFFSET }
            : { top: OFFSET, bottom: OFFSET, left: 0, right: 0 }),
        },
      }}
      onMouseDown={(downEvent) => {
        downEvent.preventDefault();

        function onMouseMove(moveEvent: MouseEvent) {
          const relevantProp = isHorizontal ? 'clientX' : 'clientY';
          const delta = moveEvent[relevantProp] - downEvent[relevantProp];

          onChange(value + delta);
        }

        function onMouseUp() {
          window.removeEventListener('mousemove', onMouseMove);
          window.removeEventListener('mouseup', onMouseUp);
        }

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      }}
    />
  );
}
